import { Center, Paper, Stack, Text, Title } from '@mantine/core'
import type { PropsWithChildren, ReactNode } from 'react'

type Props = PropsWithChildren<{
  title: string
  subtitle?: ReactNode
  maw?: number
}>

export const AuthShell = ({ title, subtitle, children, maw = 440 }: Props) => (
  <Center mih="100vh" px="md" bg="gray.0">
    <Stack gap="xl" w="100%" maw={maw} align="center">
      <Paper shadow="xl" radius="lg" withBorder w="100%">
        <Stack gap="lg" px="xl" py="xl">
          <Stack gap={4} align="center">
            <Title order={2} fw={700} ta="center">
              {title}
            </Title>
            {subtitle ? (
              <Text size="sm" c="dimmed" ta="center">
                {subtitle}
              </Text>
            ) : null}
          </Stack>
          {children}
        </Stack>
      </Paper>
    </Stack>
  </Center>
)
